import { render, staticRenderFns } from "./OrganismTicketDetail.vue?vue&type=template&id=2c48b734&scoped=true&"
import script from "./OrganismTicketDetail.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketDetail.vue?vue&type=style&index=0&id=2c48b734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48b734",
  null
  
)

export default component.exports